import * as yup from "yup";

export const schema = yup
  .object({
    comments: yup.string().required(),
  })
  .required();
